import { DateTime } from "luxon";

export const convertToMexicanDate = (fecha) => {
  const fechaConvertida = DateTime.fromISO(fecha)
    .setZone("America/Mexico_City")
    .toFormat("dd-MM-yyyy");
  return fechaConvertida;
};
